// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"3f0313c4","787":"efb4366c","958":"b3daa4f8","993":"6ccac6c4"}[chunkId] + ".chunk.js";
};